<template>
  <div class="ktab_tag">
    <ul>
      <li
        v-for="(item,index) in ktabname"
        :key="index"
        @click.stop="handleClick(item.key,index)"
         :class="{'nav_select_selected':item.class_true}"
      >{{item.value}}</li>
    </ul>
  </div>
</template>
<script>
export default {
    props:{
        footView:{
            type:Number,
            default:1
        },
        mainView:{
            type:Number,
            default:1
        },
        noTabName:{
            type:Array,
            default: () => ([]),
        }
    },
  data() {
    return {
      ktabname: [
        { key: 2, value: "MACD",class_true: false },
        { key: 4, value: "KDJ",class_true: false },
        { key: 4096, value: "RSI",class_true: false },
        { key: 512, value: "WR",class_true: false },
        { key: 2048, value: "DMI",class_true: false },
        { key: 8192, value: "PSY",class_true: false},
        { key: 1024, value: "OBV",class_true: false }
      ]
    };
  },
    watch:{
        mainView:{
            handler(newValue,oldValue){
                const _this=this
                if(newValue==10||newValue==11||this.footView==null){
                    return;
                }
                const arr=_this.ktabname.filter(function (item) {
                    return item.key==_this.footView
                })
                if(arr.length==0){
                    this.ktabname.map(function(val, index) {
                        index==0?val.class_true = true:val.class_true = false
                    });
                    this.$emit("changeFootKView", this.ktabname[0].key);
                }else {
                    this.ktabname.map(function(val, index) {
                        _this.footView === val.key ? (val.class_true = true) : (val.class_true = false);
                    });
                    this.$emit("changeFootKView", this.footView);
                }
                // this.$refs.graph2.changeFootState(newValue);
            },
            deep:true
        },
        footView:{
            handler(newValue,oldValue){
                // this.$refs.graph2.changeFootState(newValue);
            },
            deep:true
        }
    },
   created() {
      const _this = this;
     this.ktabname=this.ktabname.filter(item=>{
         return !_this.noTabName.join('').includes(item.value)
     })
     this.ktabname[0].class_true = true;
  },
  methods: {
    handleClick(key,i) {
      this.$emit("changeFootKView", key);
       this.ktabname.map(function(val, index) {
        i === index ? (val.class_true = true) : (val.class_true = false);
      });
    }
  }
};
</script>
<style  scoped lang="scss">
.ktab_tag {
  // width: 100% !important;
  ul{
    display: flex;
    align-content: center;
    // padding-left: 16px;
    margin: 0;
    li{
      list-style: none;
      width: 67px;
      height: 22px;
      font-size: 12px;
      line-height: 22px;
      background: rgba(232, 241, 255, 1);
      text-align: center;
      margin: 0 1px;
      cursor: pointer;
      color:#333333;
      margin-top: 3px;
    }
    li:hover {
      color: #4eabf9;
    }
    li.nav_select_selected {
      background: #4eabf9;
      color: #fff;
    }
  }
}
</style>
